import { type Route } from '@/types/route'

import { getFirstPossibleRoute } from '../utils/getFirstPossibleRoute'

export const diningHallTabRoutes = [
  {
    path: 'menu-planner',
    name: 'menu-planner' as const,
    meta: {
      title: 'Menu planner',
      tab: 'administration',
      permissions: ['menu.view_daymenu']
    },
    component: () => import('@/views/DiningHall/MenuPlanner/MenuPlanner.vue')
  },
  {
    path: 'meal-attendance',
    name: 'meal-attendance' as const,
    meta: {
      title: 'Meal attendance',
      tab: 'administration',
      permissions: ['permissions.view_mealattendance']
    },
    component: () =>
      import('@/views/DiningHall/MealAttendance/MealAttendance.vue')
  }
] satisfies Route[]

export const diningHallRoutes = [
  {
    path: 'dining-hall',
    name: 'dining-hall' as const,
    component: () => import('@/components/base/BaseLayout.vue'),
    props: {
      routes: diningHallTabRoutes
    },
    meta: {
      title: 'Dining hall',
      icon: 'coffee',
      tab: 'administration'
    },
    redirect: () => getFirstPossibleRoute(diningHallTabRoutes),
    children: diningHallTabRoutes
  }
] satisfies Route[]
